import * as React from 'react';


import { Paper, Typography, LinearProgress } from '@material-ui/core';

import { Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, BarChart, Tooltip, ReferenceLine, Legend } from 'recharts';

// tslint:disable-next-line:no-empty-interface
export interface IConsultingPublisherSalesEvolutionProps {
    data: any;
    loading: boolean;
    title: string;
    type: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IConsultingPublisherSalesEvolutionState {
    customFilter: {
        isChart: boolean
    },
}

export interface IConsultingPublisherSalesEvolutionDataChart {
    diference_label?: string,

    origin: string;

    market_value_evolution: number;
    market_value_evolution_label?: string;

    value_evolution: number;
    value_evolution_label?: string;
}

// statless component
const ConsultingPublisherSalesEvolutionDataChart = ({ data }: { data: IConsultingPublisherSalesEvolutionDataChart[] }) => (
    <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 30, right: 20, left: 14, bottom: 10 }}>
          <CartesianGrid vertical={false} horizontal={false} />
          <XAxis dataKey="origin"/>
          <YAxis />
          <Tooltip content={<ConsultingPublisherSalesEvolutionTooltipData />} />
          <Legend />
          <ReferenceLine y={0} stroke='#000'/>
          <Bar name='Mercado' dataKey='market_value_evolution' barSize={20} fill='#323232'/>
          <Bar name='Fornecedor' dataKey='value_evolution' barSize={20} fill='#FF6A14'/>
       </BarChart>
    </ResponsiveContainer>
);

// statless component
const ConsultingPublisherSalesEvolutionTooltipData = (props: any) => {

    let content;
    props.payload !== null &&  props.payload !== 0 &&  props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (
        <div className="tooltip-box">
            <table>
                <tbody>
                    <tr className="tooltip-text">
                        <td className="tooltip-title">Crescimento{content && ' '+content.origin}:</td>
                        <td className="tooltip-content">{content && content.value_evolution_label}</td>
                    </tr>
                    <tr className="tooltip-text">
                        <td className="tooltip-title">Crescimento Mercado:</td>
                        <td className="tooltip-content">{content && content.market_value_evolution_label}</td>
                    </tr>
                    <tr className="tooltip-text">
                        <td className="tooltip-title">Divergência do Mercado:</td>
                        <td className="tooltip-content">{content && content.diference_label}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
};

const dataFilled = (data: any) => {
    return data && data.consultingPublisherSalesEvolution && !!data.consultingPublisherSalesEvolution.length
}

export class ConsultingPublisherSalesEvolution extends React.Component<IConsultingPublisherSalesEvolutionProps, IConsultingPublisherSalesEvolutionState> {
    constructor(props: IConsultingPublisherSalesEvolutionProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
        }
    }
    public render() {

        return (
            <Paper className="publisher-sale-block panel-block" >
                <Typography variant="headline" className="panel-title" component="title">
                    {this.props.title}
                </Typography>
                {
                    this.props.loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(this.props.data)
                        ?
                        (<ConsultingPublisherSalesEvolutionDataChart data={this.consultingPublisherSalesEvolutionDataChartMap(this.props.data.consultingPublisherSalesEvolution)} />)
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        );
    }

    private consultingPublisherSalesEvolutionDataChartMap = (data: any[]) => {

        const mappedData: IConsultingPublisherSalesEvolutionDataChart[] = [];

        // data.forEach(e => {

            const item: IConsultingPublisherSalesEvolutionDataChart = {
                origin:                 data[0].origin,

                market_value_evolution:        this.props.type === 'VOLUME' ? 
                                            Number(data[1].volume_evolution.toString()) : 
                                            Number(data[1].billing_evolution.toString()),
                market_value_evolution_label:  this.props.type === 'VOLUME' ? 
                                            (Number(data[1].volume_evolution.toString()).toFixed(2) + ' %') : 
                                            (Number(data[1].billing_evolution.toString()).toFixed(2) + ' %'),

                value_evolution:        this.props.type === 'VOLUME' ? 
                                            Number(data[0].volume_evolution.toString()) : 
                                            Number(data[0].billing_evolution.toString()),
                value_evolution_label:  this.props.type === 'VOLUME' ? 
                                            (Number(data[0].volume_evolution.toString()).toFixed(2) + ' %') : 
                                            (Number(data[0].billing_evolution.toString()).toFixed(2) + ' %')
            };

            item.diference_label = ((item.value_evolution - item.market_value_evolution).toFixed(2) + ' %');

            mappedData.push(item);

        // });
        return mappedData;
    }
}



// WEBPACK FOOTER //
// ./src/component/consulting/publisher/salesEvolution/ConsultingPublisherSalesEvolution.tsx